import React from 'react';
import PropTypes from 'prop-types';
import settings from 'settings';
import _ from 'lodash';
import REDUCER_KEY from 'reducers/reducer.keys';
import { connect } from 'react-redux';
import {
  Col, DatePicker, Form, Row
} from 'antd';
import {
  convertToSelect, getKey, getLabel, setLowerDateRange, setUpperDateRange
} from 'library/helpers';
import ExtendedSelect from 'components/extendedSelect/extended-select';
import { FormWrapper } from 'components/Page';
import { list } from 'actions';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  cycles: state.api.availabilityCycles.data.results,
  inFlight: state.api.availabilityCycles.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadCycles(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    return dispatch(list(REDUCER_KEY.availabilityCycles.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const { availability_cycle, start_datetime, end_datetime } = dataSource;
  return {
    availability_cycle: Form.createFormField({ value: convertToSelect(availability_cycle) }),
    start_datetime: Form.createFormField({ value: start_datetime }),
    end_datetime: Form.createFormField({ value: end_datetime })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, inputFormItemLayout, form, cycles, inFlight, loadCycles
}) => {
  const { getFieldDecorator } = form;
  const { availability_cycle, start_datetime, end_datetime } = dataSource;
  const readonly = !canAdmin;

  return (
    <Form>
      <Row {...inputFormItemLayout.row}>
        <Col {...inputFormItemLayout.col}>
          <FormItem {...inputFormItemLayout.inputLayout} label="Cycle">
            {getFieldDecorator('availability_cycle', {
              initialValue: availability_cycle,
              rules: [
                {
                  required: true,
                  message: 'Please select a Cycle.'
                }
              ]
            })(
              <ExtendedSelect
                placeholder="Select Cycle"
                fetching={inFlight}
                dataSource={cycles}
                optionKey={getKey}
                optionLabel={getLabel}
                onSearch={loadCycles}
                onFocus={loadCycles}
                disabled={readonly}
              />
            )}
          </FormItem>
        </Col>
      </Row>
      <Row {...inputFormItemLayout.row}>
        <Col {...inputFormItemLayout.col}>
          <FormItem {...inputFormItemLayout.inputLayout} label="Start Date">
            {getFieldDecorator('start_datetime', {
              initialValue: start_datetime,
              rules: [
                {
                  required: true,
                  message: 'Please enter a Start Date.'
                }
              ]
            })(
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="DD-MM-YYYY HH:mm"
                disabledDate={startValue => setUpperDateRange(startValue, end_datetime)}
                disabled={readonly}
              />
            )}
          </FormItem>
        </Col>
      </Row>
      <Row {...inputFormItemLayout.row}>
        <Col {...inputFormItemLayout.col}>
          <FormItem {...inputFormItemLayout.inputLayout} label="End Date">
            {getFieldDecorator('end_datetime', {
              initialValue: end_datetime
            })(
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="DD-MM-YYYY HH:mm"
                disabledDate={endValue => setLowerDateRange(endValue, start_datetime)}
                disabled={readonly}
              />
            )}
          </FormItem>
        </Col>
      </Row>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  form: PropTypes.object,
  dataSource: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  cycles: PropTypes.array,
  inFlight: PropTypes.bool,
  loadCycles: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  form: {},
  dataSource: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  },
  cycles: [],
  inFlight: false,
  loadCycles() {
  }
};

const ConnectedFormInput = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormInput);

const UserCycleFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default UserCycleFormInput;
